import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/web/app/screens/category/category.tsx");
